import { useState, useCallback, type RefObject } from "react";

export function useScrollFade(listBoxRef: RefObject<HTMLElement | null>) {
  const [canScrollUp, setCanScrollUp] = useState(false);
  const [canScrollDown, setCanScrollDown] = useState(false);

  const updateScrollState = useCallback(() => {
    const listBox = listBoxRef.current;
    if (!listBox) return;
    const { scrollTop, scrollHeight, clientHeight } = listBox;
    setCanScrollUp(scrollTop > 1);
    setCanScrollDown(scrollTop < scrollHeight - clientHeight - 1);
  }, [listBoxRef]);

  const resetScrollState = useCallback(() => {
    setCanScrollUp(false);
    setCanScrollDown(false);
  }, []);

  const initScrollState = useCallback((canScrollDownInitial: boolean) => {
    setCanScrollUp(false);
    setCanScrollDown(canScrollDownInitial);
  }, []);

  return { canScrollUp, canScrollDown, updateScrollState, resetScrollState, initScrollState };
}
